import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

const LogoutComponent = ({ show, handleClose }) => {
    return (
        <Modal show={show} onHide={handleClose} backdrop="static"
        keyboard={false} contentClassName="logout-modal-size" centered="true">
            <Modal.Header className="beck-modal-header">
                <Modal.Title className="beck-modal-title">Logged Out</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="text-center vertical-middle">You have been logged out.</div>
            </Modal.Body>

            <Modal.Footer className="beck-modal-footer">
                <Button variant="primary" size="lg" onClick={handleClose}>Ok</Button>
            </Modal.Footer>
        </Modal>
    )
}

export {
    LogoutComponent
}